import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./index.module.css";

/**
 * Shared Collapse / Expand toggle used by the standalone editor panels
 * (Thumbnail, Product Images, Pricing, Content Settings, …) so they match the
 * affordance already provided by CollapsibleSection. The collapsed state lives
 * in the parent; this is a presentational button only.
 */
export default function CollapseToggle({ collapsed, onToggle, className }) {
  return (
    <button
      type="button"
      className={classNames(styles.toggle, className)}
      aria-expanded={!collapsed}
      onClick={onToggle}
      title={collapsed ? "Expand this section" : "Collapse this section"}
    >
      {collapsed ? "Expand" : "Collapse"}
    </button>
  );
}

CollapseToggle.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
};

CollapseToggle.defaultProps = {
  className: "",
};
